const STORAGE_KEY_PREFIX = 'emergency_access_';

export function getStoredEmergencyToken(patientId) {
    try {
        const raw = localStorage.getItem(STORAGE_KEY_PREFIX + patientId);
        if (!raw) return null;
        const { token, expiresAt } = JSON.parse(raw);
        if (!token || !expiresAt) return null;
        if (new Date(expiresAt) <= new Date()) {
            localStorage.removeItem(STORAGE_KEY_PREFIX + patientId);
            return null;
        }
        return token;
    } catch {
        return null;
    }
}

export function storeEmergencyToken(patientId, token, expiresAt) {
    localStorage.setItem(
        STORAGE_KEY_PREFIX + patientId,
        JSON.stringify({ token, expiresAt })
    );
}

export function removeEmergencyToken(patientId) {
    localStorage.removeItem(STORAGE_KEY_PREFIX + patientId);
}
